import { getAccessibleColorFromBackgroundValue } from './contrastUtils';
export const getNeutralSkeleton100ValueFromBackground = (backgroundColor)=>{
    return getAccessibleColorFromBackgroundValue(backgroundColor, [
        900,
        800
    ], [
        0,
        100
    ]);
};
export const getNeutralSkeleton150ValueFromBackground = (backgroundColor)=>{
    return getAccessibleColorFromBackgroundValue(backgroundColor, [
        900,
        750
    ], [
        0,
        150
    ]);
};
export const getNeutralProgress200ValueFromBackground = (backgroundColor)=>{
    return getAccessibleColorFromBackgroundValue(backgroundColor, [
        900,
        700
    ], [
        0,
        200
    ]);
};
export const getNeutralProgress900ValueFromBackground = (backgroundColor)=>{
    return getAccessibleColorFromBackgroundValue(backgroundColor, [
        900,
        0
    ], [
        0,
        900
    ]);
};
export const getNeutral100ValueFromBackground = (backgroundColor)=>{
    return getAccessibleColorFromBackgroundValue(backgroundColor, [
        900,
        800
    ], [
        0,
        100
    ]);
};

//# sourceMappingURL=colorDerivingUtils.js.map